import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  height: 100%;\n  right: 0;\n  border: 0;\n  padding-right: 10px;\n  font-size: 12px;\n  color: ", ";\n  background: transparent;\n  cursor: pointer;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  & input {\n    padding: 0 50px 0 16px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState } from 'react';
import styled from '../../utils/styling/styled-components';
import { PRIVATE_INPUT_TOGGLE, TEXT_INPUT } from '../../utils/testing/TestIDs';
import { BaseTextInputV2 } from './BaseTextInputV2';
import { HelperText } from './HelperText';
var StyledTextInput = styled(BaseTextInputV2)(_templateObject());
var StyledShowButton = styled.button(_templateObject2(), function (props) {
  return props.theme.colors.slate;
});

var ShowButton = function ShowButton(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(StyledShowButton, {
    "data-testid": PRIVATE_INPUT_TOGGLE,
    onClick: onClick
  }, children);
};

var PrivateInputV2 = function PrivateInputV2(_ref2) {
  var className = _ref2.className,
      customToggle = _ref2.customToggle,
      error = _ref2.error,
      errorText = _ref2.errorText,
      _ref2$isRevealable = _ref2.isRevealable,
      isRevealable = _ref2$isRevealable === void 0 ? true : _ref2$isRevealable,
      label = _ref2.label,
      helperText = _ref2.helperText,
      inputProps = _ref2.inputProps,
      _ref2$revealedInputTy = _ref2.revealedInputType,
      revealedInputType = _ref2$revealedInputTy === void 0 ? 'text' : _ref2$revealedInputTy;
  var Toggle = customToggle ? customToggle : ShowButton;

  var _useState = useState('password'),
      _useState2 = _slicedToArray(_useState, 2),
      inputType = _useState2[0],
      setInputType = _useState2[1];

  var hideOrShowText = inputType === 'password' ? 'Show' : 'Hide';

  var handleShow = function handleShow() {
    if (inputType === 'password') {
      setInputType(revealedInputType);
    } else {
      setInputType('password');
    }
  };

  return /*#__PURE__*/React.createElement(StyledTextInput, {
    className: className,
    adornments: {
      right: isRevealable && !inputProps.disabled && /*#__PURE__*/React.createElement(Toggle, {
        onClick: handleShow
      }, hideOrShowText)
    },
    error: error,
    errorText: errorText,
    decorators: {
      bottom: helperText && /*#__PURE__*/React.createElement(HelperText, null, helperText)
    },
    inputProps: _objectSpread(_objectSpread({}, inputProps), {}, {
      'data-testid': TEXT_INPUT,
      type: inputType
    }),
    label: label
  });
};

export { PrivateInputV2 };